import ApiUtils from "../ApiUtils";

export default class ApiCmsService {

    async getPolicyContent(policyType) {
        return await ApiUtils.callApi(`cms/policy/${policyType}`,'get');
    }

    async updatePolicyContent(data) {
        return await ApiUtils.callApi(`cms/policy`,'post', data);
    }
}